"use client"
import { Spin, Typography } from "antd"
import styles from "./ListingsFilter.module.scss"
import "nouislider/dist/nouislider.css"
import { ArrowLeft } from "@css/icons/ArrowLeft"
import { PointsOnContract } from "./components/fields/PointsOnContract"
import { PricePerPoint } from "./components/fields/PricePerPoint"
import { MaxContractPrice } from "./components/fields/MaxContractPrice"
import { StarsRating } from "./components/fields/StarsRating"
import { TagsResort } from "./components/fields/TagsResort"
import { TagsStatus } from "./components/fields/TagsStatus"
import { TagsUseMonth } from "./components/fields/TagsUseMonth"
import { TagsBrokerStatus } from "./components/fields/TagsBrokerStatus"
import { TagsOrigin } from "./components/fields/TagsOrigin"
import { ToggleActive } from "@components/Listings/ListingsFilter/components/fields/ToggleActive"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"

const { Title } = Typography

// Export the wrapped component
export default function ListingsFilter({ resort, total }) {
    const open = useFilterStore((s) => s.open)
    const loading = useFilterStore((s) => s.loading)
    const toggleDrawerOpen = useFilterStore((s) => s.toggleDrawerOpen)
    const clearAll = useFilterStore((s) => s.clearAll)
    return (
        <>
            {open && <div className={styles.asideClose} onClick={toggleDrawerOpen} />}
            <div className={styles.aside} data-open={open}>
                {loading && (
                    <div className={styles.spinner}>
                        <Spin size="large" />
                    </div>
                )}
                <div className={styles.asideSpacing}>
                    <div className={styles.titleWrapper}>
                        <Title level={2} onClick={toggleDrawerOpen} className={styles.title}>
                            <ArrowLeft />
                            Filter<span>by category</span>
                        </Title>
                        <button onClick={clearAll} className={styles.resetFiltersBtn}>
                            clear all
                        </button>
                    </div>
                    <PointsOnContract />
                    <PricePerPoint />
                    <MaxContractPrice />
                    <StarsRating />
                    {!resort && <TagsResort />}
                    <TagsUseMonth />
                    <TagsStatus />
                    <TagsBrokerStatus />
                    <TagsOrigin />
                    <ToggleActive />
                </div>
                <div className={styles.expand} />
                <div className={styles.filterBottomBtns}>
                    <button onClick={clearAll} className={styles.resetAllBtn}>
                        Reset all
                    </button>
                    <button onClick={toggleDrawerOpen} className={styles.seeListingsBtn}>
                        {`See ${total} listings`}
                    </button>
                </div>
            </div>
        </>
    )
}
